import {t} from "../i18n.js"

/** Select §18.6: behavior copied from the canonical guide, with native form values preserved.
 * Integration adds lifecycle synchronization for LiveView patches and external SVG URLs.
 */
let installed;
export function installAiosSelects(root = document) {
 if (installed) {installed.sync(); return installed;}
 const html=document.documentElement, enhanced=new WeakMap(), controls=new Set();
  const SEL_ROWS = 8, SEL_SEARCH = 10, SEL_NEAR = 28, SVGNS = 'http://www.w3.org/2000/svg';
  let selSeq = 0, selCur = null, taBuf = '', taTimer;
  const svgIc = (id, cls = '') => {const s = document.createElementNS(SVGNS, 'svg'), u = document.createElementNS(SVGNS, 'use'); s.setAttribute('class', ('ic ' + cls).trim()); s.setAttribute('aria-hidden', 'true'); u.setAttribute('href', '/images/aios/design-system/icons.svg#' + id); s.append(u); return s;};
  const fold = s => s.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
  /* trecho encontrado, em índices do texto original (a busca ignora acento e caixa) */
  const hit = (text, q) => {
    if (!q || !text) return null; const chars = [...text], map = []; let s = '';
    chars.forEach((c, i) => {const f = fold(c); for (let j = 0; j < f.length; j++) map.push(i); s += f;});
    const k = s.indexOf(q); return k < 0 ? null : [map[k], map[k + q.length - 1] + 1];
  };
  const marked = (text, range) => {
    const f = document.createDocumentFragment(); if (!range) {f.append(text); return f;}
    const c = [...text], m = document.createElement('mark'); m.textContent = c.slice(range[0], range[1]).join('');
    f.append(c.slice(0, range[0]).join(''), m, c.slice(range[1]).join('')); return f;
  };
  const optData = o => {const g = o.parentElement.tagName === 'OPTGROUP' ? o.parentElement : null; return {el:o, label:o.label, desc:o.dataset.desc || '', code:o.dataset.code || '', icon:o.dataset.icon || '', av:o.dataset.av || '', tone:o.dataset.tone || 'blue', group:g ? g.label : '', disabled:o.disabled || !!g?.disabled};};
  const readOpts = sel => [...sel.options].filter(o => !o.hidden).map(optData);
  const lead = o => {
    if (o.av) {const a = document.createElement('span'); a.className = `av av--xs av--${o.tone}`; a.setAttribute('aria-hidden', 'true'); a.textContent = o.av; return a;}
    return o.icon ? svgIc(o.icon) : null;
  };
  const selPaint = (sel, btn) => {
    const o = sel.options[sel.selectedIndex], ph = !o || (o.value === '' && (o.hidden || o.disabled));
    btn.toggleAttribute('data-placeholder', ph);
    btn.querySelectorAll(':scope>.av,:scope>.sel__code,:scope>.ic:not(.sel__chev)').forEach(n => n.remove());
    const val = btn.querySelector('.sel__val'); val.textContent = o ? o.label : '';
    if (o && !ph) {
      const d = optData(o), l = lead(d); if (l) val.before(l);
      if (d.code) {const c = document.createElement('span'); c.className = 'sel__code'; c.textContent = d.code; val.before(c);}
    }
  };
  const selMetrics = st => {
    const {list, frame, thumb} = st, sh = list.scrollHeight, ch = list.clientHeight, can = sh > ch + 1;
    frame.toggleAttribute('data-scrollable', can);
    if (!can) {delete frame.dataset.fade; delete frame.dataset.scroll; return;}
    const track = ch - 8, th = Math.max(24, Math.round(track * ch / sh));
    thumb.style.height = th + 'px'; thumb.style.transform = `translateY(${4 + (track - th) * list.scrollTop / (sh - ch)}px)`;
    const atTop = list.scrollTop <= 1, atEnd = list.scrollTop >= sh - ch - 1;
    frame.dataset.fade = atTop ? 'bottom' : atEnd ? 'top' : 'both';
  };
  /* mantém o item ativo visível, com 14px de folga para não cair no esmaecimento; o título do grupo vem junto */
  const selKeep = (st, r) => {
    const {list} = st, head = r.previousElementSibling?.classList.contains('sel__head') ? r.previousElementSibling : null;
    const top = (head || r).offsetTop - 14, bot = r.offsetTop + r.offsetHeight + 14;
    if (top < list.scrollTop) list.scrollTop = top; else if (bot > list.scrollTop + list.clientHeight) list.scrollTop = bot - list.clientHeight;
  };
  const selActive = (st, r, scroll = true) => {
    st.active?.removeAttribute('data-active'); st.active = r; const owner = st.input || st.btn;
    if (!r) {owner?.removeAttribute('aria-activedescendant'); return;}
    r.setAttribute('data-active', ''); owner?.setAttribute('aria-activedescendant', r.id);
    if (scroll) selKeep(st, r);
  };
  const selRender = (st, q) => {
    const f = fold(q.trim()), {list} = st; let group = null, gEl = null;
    list.textContent = ''; st.items = [];
    st.opts.forEach((o, i) => {
      const hl = hit(o.label, f), hc = hit(o.code, f), hd = hit(o.desc, f);
      if (f && !hl && !hc && !hd) return;
      if (o.group !== group) {
        group = o.group; gEl = null;
        if (group) {const h = document.createElement('div'); gEl = document.createElement('div'); gEl.className = 'sel__group'; gEl.setAttribute('role', 'group'); h.className = 'menu__head sel__head'; h.id = `${st.id}-g${i}`; h.textContent = group; gEl.setAttribute('aria-labelledby', h.id); gEl.append(h); list.append(gEl);}
      }
      const r = document.createElement('div'), t = document.createElement('span'), l = document.createElement('span');
      r.className = 'sel__opt'; r.id = `${st.id}-o${i}`; r.dataset.i = i; r.setAttribute('role', 'option'); r.setAttribute('aria-selected', String(o.el === st.selected));
      if (o.disabled) r.setAttribute('aria-disabled', 'true');
      const ld = lead(o); if (ld) r.append(ld);
      if (o.code) {const c = document.createElement('span'); c.className = 'sel__code'; c.append(marked(o.code, hc)); r.append(c);}
      t.className = 'sel__txt'; l.className = 'sel__lbl'; l.append(marked(o.label, hl)); t.append(l);
      if (o.desc) {const d = document.createElement('span'); d.className = 'sel__desc'; d.append(marked(o.desc, hd)); t.append(d);}
      r.append(t, svgIc('i-check', 'sel__check')); (gEl || list).append(r); st.items.push(r);
    });
    st.empty.hidden = st.items.length > 0; st.empty.querySelector('span').textContent = t('No items for “%{query}”.', {query:q.trim()});
    if (st.count) st.count.textContent = f ? t('%{count} of %{total}', {count:st.items.length, total:st.opts.length}) : t('Items: %{count}', {count:st.opts.length});
    if (st.input) st.input.setAttribute('aria-expanded', String(st.items.length > 0));
    const enabled = st.items.filter(r => !r.hasAttribute('aria-disabled'));
    list.scrollTop = 0;
    selActive(st, (!f && st.items.find(r => r.getAttribute('aria-selected') === 'true')) || enabled[0] || null, !f);
    /* rótulo cortado ganha tooltip com o texto inteiro */
    st.items.forEach(r => {const lb = r.querySelector('.sel__lbl'); if (lb.scrollWidth > lb.clientWidth) r.dataset.tip = r.querySelector('.sel__code') ? `${st.opts[r.dataset.i].code} ${lb.textContent}` : lb.textContent;});
    selMetrics(st);
  };
  /* limite de altura: 8 itens e meio quando há mais de 8 (medido na lista completa, sem busca) */
  const selCap = st => {
    st.list.style.maxHeight = 'none'; const rows = st.list.querySelectorAll('.sel__opt');
    st.cap = rows.length > SEL_ROWS ? Math.round(rows[SEL_ROWS].offsetTop + rows[SEL_ROWS].offsetHeight / 2) : Infinity;
  };
  const selTypeahead = (st, ch) => {
    clearTimeout(taTimer); taTimer = setTimeout(() => taBuf = '', 600); taBuf += fold(ch);
    const en = st.items.filter(r => !r.hasAttribute('aria-disabled')), k = en.indexOf(st.active);
    const same = [...taBuf].every(c => c === taBuf[0]), q = same ? taBuf[0] : taBuf, from = same ? k + 1 : Math.max(k, 0);
    const r = [...en.slice(from), ...en.slice(0, from)].find(r => fold(st.opts[r.dataset.i].label).startsWith(q)); if (r) selActive(st, r);
  };
  const selKey = (st, e) => {
    const en = st.items.filter(r => !r.hasAttribute('aria-disabled')), k = en.indexOf(st.active);
    const go = j => {e.preventDefault(); if (en.length) selActive(st, en[Math.max(0, Math.min(en.length - 1, j))]);};
    const pick = () => {e.preventDefault(); if (st.btn) st.btn.kbAt = performance.now(); if (st.active) st.choose(st.active);};
    switch (e.key) {
      case 'ArrowDown': return go(k + 1);
      case 'ArrowUp': return e.altKey ? pick() : go(k < 0 ? 0 : k - 1);
      case 'PageDown': return go(k + SEL_ROWS);
      case 'PageUp': return go(Math.max(0, k - SEL_ROWS));
      case 'Home': case 'End': if (st.input) return; return go(e.key === 'Home' ? 0 : en.length - 1);
      case 'Enter': return pick();
      case 'Escape': e.preventDefault(); e.stopPropagation(); return st.dismiss?.(true);
      case 'Tab': return st.dismiss?.(true);
    }
    if (st.input || e.ctrlKey || e.metaKey || e.altKey || e.key.length !== 1) return;
    if (e.key === ' ' && !taBuf) return pick();
    e.preventDefault(); selTypeahead(st, e.key);
  };
  const selBindScroll = st => {
    const {pop, frame, list, thumb} = st; let near = false, drag = null, t;
    const show = () => {clearTimeout(t); if (frame.hasAttribute('data-scrollable')) frame.dataset.scroll = 'show';};
    const hide = ms => {clearTimeout(t); t = setTimeout(() => {if (!near && !drag) delete frame.dataset.scroll;}, ms);};
    const rolled = () => {show(); hide(800);};
    list.addEventListener('wheel', rolled, {passive:true});
    list.addEventListener('touchmove', rolled, {passive:true});
    list.addEventListener('scroll', () => selMetrics(st), {passive:true});
    pop.addEventListener('pointermove', e => {
      if (e.pointerType === 'touch' || drag) return; const r = list.getBoundingClientRect();
      const n = e.clientY >= r.top && e.clientY <= r.bottom && Math.abs(r.right - e.clientX) <= SEL_NEAR;
      if (n !== near) {near = n; n ? show() : hide(400);}
    });
    pop.addEventListener('pointerleave', () => {if (near && !drag) {near = false; hide(400);}});
    thumb.addEventListener('pointerdown', e => {e.preventDefault(); drag = {y:e.clientY, top:list.scrollTop}; thumb.setPointerCapture(e.pointerId); thumb.classList.add('is-drag'); show();});
    thumb.addEventListener('pointermove', e => {if (!drag) return; const ch = list.clientHeight, track = ch - 8 - thumb.offsetHeight; if (track > 0) list.scrollTop = drag.top + (e.clientY - drag.y) * (list.scrollHeight - ch) / track;});
    const end = () => {if (!drag) return; drag = null; thumb.classList.remove('is-drag'); if (!near) hide(800);};
    thumb.addEventListener('pointerup', end); thumb.addEventListener('pointercancel', end);
  };
  const selBuild = ({opts, name, selected, fixed = false}) => {
    const id = `sel-p${++selSeq}`, pop = document.createElement('div'), frame = document.createElement('div'), list = document.createElement('div'), thumb = document.createElement('div'), empty = document.createElement('div');
    const st = {id, pop, frame, list, thumb, empty, opts, selected, items:[], active:null, input:null, count:null, cap:Infinity, chrome:0};
    pop.className = 'sel-pop' + (fixed ? ' sel-pop--static' : ''); pop.id = id;
    frame.className = 'sel__frame'; thumb.className = 'sel__thumb'; thumb.setAttribute('aria-hidden', 'true');
    list.className = 'sel__list'; list.id = id + '-l'; list.setAttribute('role', 'listbox'); if (name) list.setAttribute('aria-label', name);
    if (opts.length > SEL_SEARCH) {
      const wrap = document.createElement('div'), input = document.createElement('input'), count = document.createElement('span');
      pop.setAttribute('role', 'dialog'); if (name) pop.setAttribute('aria-label', name);
      wrap.className = 'sel__search'; count.className = 'sel__count'; count.setAttribute('aria-live', 'polite');
      Object.assign(input, {className:'input', type:'text', placeholder:t('Search…'), autocomplete:'off', spellcheck:false});
      input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-controls', list.id); input.setAttribute('aria-label', name ? t('Search in %{name}', {name}) : t('Search'));
      input.addEventListener('input', () => {selRender(st, input.value); st.place?.();});
      input.addEventListener('keydown', e => selKey(st, e));
      input.addEventListener('change', e => e.stopPropagation()); /* a busca não é valor de formulário */
      wrap.append(svgIc('i-search'), input, count); pop.append(wrap); Object.assign(st, {input, count});
    }
    empty.className = 'sel__empty'; empty.hidden = true; empty.innerHTML = '<span></span><button type="button" class="btn btn--ghost btn--sm"></button>';
    empty.querySelector('button').textContent = t('Clear search');
    empty.querySelector('button').addEventListener('click', () => {st.input.value = ''; selRender(st, ''); st.place?.(); st.input.focus({preventScroll:true});});
    frame.append(list, thumb); pop.append(frame, empty);
    pop.addEventListener('mousedown', e => {if (e.target !== st.input) e.preventDefault();});
    list.addEventListener('pointermove', e => {const r = e.target.closest('.sel__opt'); if (r && r !== st.active && !r.hasAttribute('aria-disabled')) selActive(st, r, false);});
    list.addEventListener('click', e => {const r = e.target.closest('.sel__opt'); if (r && !r.hasAttribute('aria-disabled')) st.choose(r);});
    selBindScroll(st);
    return st;
  };
  const selPlace = (st, first = false) => {
    const r = st.btn.getBoundingClientRect(), vw = html.clientWidth, vh = innerHeight, gap = 6, m = 8;
    if (r.bottom < 0 || r.top > vh) return selClose(false);
    const w = Math.min(Math.max(r.width, 180), vw - 2 * m);
    st.pop.style.width = w + 'px'; st.pop.style.left = Math.min(Math.max(m, r.left), vw - m - w) + 'px';
    if (first) {
      st.chrome = st.pop.offsetHeight - st.list.offsetHeight;
      const need = st.chrome + Math.min(st.list.scrollHeight, st.cap), below = vh - r.bottom - gap - m, above = r.top - gap - m;
      st.side = need <= below || below >= above ? 'bottom' : 'top'; st.pop.dataset.side = st.side;
    }
    const room = (st.side === 'bottom' ? vh - r.bottom : r.top) - gap - m - st.chrome;
    st.list.style.maxHeight = Math.max(0, Math.min(st.cap, room)) + 'px';
    if (st.side === 'bottom') {st.pop.style.top = r.bottom + gap + 'px'; st.pop.style.bottom = 'auto';}
    else {st.pop.style.top = 'auto'; st.pop.style.bottom = vh - r.top + gap + 'px';}
    selMetrics(st);
  };
  /* Drawers and modals are promoted to the top layer (aios_overlays.js), where no body-level
     z-index can reach them: a list appended to <body> would open BEHIND the drawer that holds
     its select. The list joins the top layer too, after the overlay, so it always paints above it. */
  const selTopLayer = pop => {
    if (typeof pop.showPopover !== 'function') return;
    pop.setAttribute('popover', 'manual');
    try { pop.showPopover(); } catch (_) { pop.removeAttribute('popover'); }
  };
  const selClose = refocus => {
    const st = selCur; if (!st) return; selCur = null; st.pop.remove();
    st.btn.setAttribute('aria-expanded', 'false'); st.btn.removeAttribute('aria-controls'); st.btn.removeAttribute('aria-activedescendant');
    st.btn.removeEventListener('focusout', st.out); st.input?.removeEventListener('focusout', st.out);
    if (refocus) st.btn.focus({preventScroll:true});
  };
  const selOpen = (sel, btn, seed = '') => {
    selClose(false); if (btn.disabled) return;
    const name = btn.getAttribute('aria-label') || document.getElementById(btn.getAttribute('aria-labelledby'))?.textContent.trim() || '';
    const st = selBuild({opts:readOpts(sel), name, selected:sel.options[sel.selectedIndex]});
    Object.assign(st, {sel, btn, place:() => selPlace(st), dismiss:selClose});
    st.choose = r => {
      const o = st.opts[r.dataset.i], changed = !o.el.selected; o.el.selected = true; selClose(true); selPaint(sel, btn);
      if (changed) {sel.dispatchEvent(new Event('input', {bubbles:true})); sel.dispatchEvent(new Event('change', {bubbles:true}));}
    };
    selCur = st; document.body.append(st.pop); selTopLayer(st.pop);
    btn.setAttribute('aria-expanded', 'true'); btn.setAttribute('aria-controls', st.input ? st.pop.id : st.list.id);
    selRender(st, ''); selCap(st);
    if (st.input && seed) {st.input.value = seed; selRender(st, seed);}
    selPlace(st, true); if (st.active) selKeep(st, st.active);
    (st.input || btn).focus({preventScroll:true});
    if (!st.input && seed) selTypeahead(st, seed);
    st.out = e => {if (selCur === st && e.relatedTarget && !st.pop.contains(e.relatedTarget) && e.relatedTarget !== btn) selClose(false);};
    btn.addEventListener('focusout', st.out); st.input?.addEventListener('focusout', st.out);
  };
  const selEnhance = sel => {
    if (enhanced.has(sel) && enhanced.get(sel).btn.isConnected) {
      const current=enhanced.get(sel); if(current.btn.disabled!==sel.disabled)current.btn.disabled=sel.disabled;
      /* the trigger wears the select's classes (e.g. the role pill's tone): follow a patched class */
      const cls=sel.className+' select sel__btn'; if(current.btn.className!==cls)current.btn.className=cls;
      for(const name of ['aria-invalid','aria-describedby','aria-label']){const value=sel.getAttribute(name);if(value===null){if(name!=='aria-label')current.btn.removeAttribute(name);}else if(current.btn.getAttribute(name)!==value)current.btn.setAttribute(name,value);}
      current.btn.setAttribute('aria-haspopup',readOpts(sel).length>SEL_SEARCH?'dialog':'listbox');
      selPaint(sel,current.btn);return current;
    }
    const orphan=sel.closest(".sel-wrap"); if(orphan)orphan.replaceWith(sel);
    const oldTrigger=sel.closest(".seiva-searchable")?.querySelector("[data-searchable-trigger]");
    if (oldTrigger) oldTrigger.hidden=true;
    const wrap = document.createElement('span'), btn = document.createElement('button'), val = document.createElement('span');
    wrap.className = 'sel-wrap'; ['minWidth', 'maxWidth', 'flex'].forEach(p => {if (sel.style[p]) wrap.style[p] = sel.style[p];});
    btn.type = 'button'; btn.className = sel.className + ' select sel__btn'; btn.style.cssText = sel.style.cssText; btn.style.width = btn.style.minWidth = btn.style.maxWidth = btn.style.flex = '';
    val.className = 'sel__val'; btn.append(val, svgIc('i-chev-d', 'sel__chev'));
    btn.setAttribute('role', 'combobox'); btn.setAttribute('aria-haspopup', readOpts(sel).length > SEL_SEARCH ? 'dialog' : 'listbox'); btn.setAttribute('aria-expanded', 'false');
    ['aria-invalid', 'aria-describedby'].forEach(a => {if (sel.hasAttribute(a)) btn.setAttribute(a, sel.getAttribute(a));});
    if (sel.required) btn.setAttribute('aria-required', 'true');
    btn.disabled = sel.disabled;
    const lab = (sel.id && document.querySelector(`label[for="${sel.id}"]`)) || sel.closest('label');
    if (sel.getAttribute('aria-label')) btn.setAttribute('aria-label', sel.getAttribute('aria-label'));
    else {
      const n = lab ? (lab.htmlFor ? lab : lab.querySelector('.field__label, span')) : sel.closest('.field')?.querySelector('.field__label');
      if (n) {n.id ||= `sel-l${++selSeq}`; btn.setAttribute('aria-labelledby', n.id);}
    }
    const labelClick=e=>{if (!btn.contains(e.target)) {e.preventDefault();btn.focus();}};lab?.addEventListener('click',labelClick);
    sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    sel.replaceWith(wrap); wrap.append(btn, sel); selPaint(sel, btn);
    btn.addEventListener('click', e => {
      if (e.detail === 0 && performance.now() - (btn.kbAt || 0) < 400) return; /* Enter/Espaço já trataram no keydown */
      selCur?.btn === btn ? selClose(true) : selOpen(sel, btn);
    });
    btn.addEventListener('keydown', e => {
      if (selCur?.btn === btn) {if (!selCur.input) selKey(selCur, e); return;}
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) {e.preventDefault(); btn.kbAt = performance.now(); selOpen(sel, btn);}
      else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {e.preventDefault(); selOpen(sel, btn, e.key);}
    });
    const change=()=>selPaint(sel,btn);sel.addEventListener('change',change);
    const record={sel,btn,wrap,cleanup(){lab?.removeEventListener('click',labelClick);sel.removeEventListener('change',change);}};enhanced.set(sel,record);controls.add(record);return record;
  };

 const sync=()=>{
   for(const record of controls)if(!record.sel.isConnected){record.cleanup();controls.delete(record);}
   if(selCur && (!selCur.sel.isConnected || !selCur.btn.isConnected)) selClose(false);
   root.querySelectorAll('select').forEach(sel=>{
     if(sel.multiple || sel.size>1 || sel.closest('[data-native-select]'))return;
     selEnhance(sel);
   });
 };
 const pointer=e=>{if(selCur&&!selCur.pop.contains(e.target)&&!selCur.btn.contains(e.target))selClose(false);};
 const resize=()=>selCur?.place();
 let frame=0;const scroll=e=>{if(selCur&&!selCur.pop.contains(e.target)&&!frame)frame=requestAnimationFrame(()=>{frame=0;selCur?.place();});};
 document.addEventListener('pointerdown',pointer,true);
 window.addEventListener('resize',resize);window.addEventListener('scroll',scroll,true);
 let queued=false;
 const observer=new MutationObserver(records=>{
   const relevant=records.some(record=>{
     const target=record.target.nodeType===1?record.target:record.target.parentElement;
     if(target?.closest('.sel-pop,.sel__btn'))return false;
     if(target?.matches('select,option,optgroup')||target?.closest('select'))return true;
     return [...record.addedNodes,...record.removedNodes].some(node=>node.nodeType===1&&(node.matches('select')||node.querySelector('select')));
   });
   if(!relevant)return;
   if(selCur&&records.some(record=>record.target===selCur.sel||selCur.sel.contains(record.target)))selClose(false);
   if(!queued){queued=true;queueMicrotask(()=>{queued=false;sync();});}
 });
 observer.observe(root===document?document.body:root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','selected','value','aria-invalid','class']});
 sync();
 installed={sync,enhance:selEnhance,close:()=>selClose(false),destroy(){observer.disconnect();selClose(false);cancelAnimationFrame(frame);for(const record of controls){record.cleanup();if(record.wrap.isConnected)record.wrap.replaceWith(record.sel);record.sel.removeAttribute('aria-hidden');record.sel.tabIndex=0;}controls.clear();document.removeEventListener('pointerdown',pointer,true);window.removeEventListener('resize',resize);window.removeEventListener('scroll',scroll,true);installed=null;}};
 return installed;
}
